module.exports = __webpack_public_path__ + "static/media/link.daefd42c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/link.svg
// module id = 652
// module chunks = 1